import React from 'react'
import { Text } from '../../../../../../components'
import styles from './FormHeader.module.scss'

interface FormHeaderProps {
  isLoading: boolean
  btnNode: JSX.Element
}

export const FormHeader = (props: FormHeaderProps) => (
  <div className={styles.formHeader}>
    <Text weight='light' color='white' className={styles.headerText}>
      Your Profile
    </Text>
    {props.btnNode}
  </div>
)
